import { render, staticRenderFns } from "./AddAgentbrand.vue?vue&type=template&id=1b668bc8&scoped=true"
import script from "./AddAgentbrand.vue?vue&type=script&lang=js"
export * from "./AddAgentbrand.vue?vue&type=script&lang=js"
import style0 from "./AddAgentbrand.vue?vue&type=style&index=0&id=1b668bc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b668bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b668bc8')) {
      api.createRecord('1b668bc8', component.options)
    } else {
      api.reload('1b668bc8', component.options)
    }
    module.hot.accept("./AddAgentbrand.vue?vue&type=template&id=1b668bc8&scoped=true", function () {
      api.rerender('1b668bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/AddAgentbrand.vue"
export default component.exports